var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"about",attrs:{"id":"about"}},[_c('Title',{attrs:{"title_id":"imgTitle-page-about","title_text":_vm.$t('page-title.about.title'),"subtitle_text":_vm.$t('page-title.about.subtitle')}}),_c('About'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }